import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'イラストを描かない人でも使えますか?',
      answer: 'はい、ご使用いただけます。本製品はイラストレーターの描画姿勢を起点に設計されていますが、近年増えているAI活用シーン(生成AIでの画像制作、資料作成、構成設計、アイデア出しなど)にも適しています。iPadでChatGPTや画像生成AIを活用しながら手書きで修正・構図ラフを行うビジネスマンやクリエーターにとっても、自然な角度と安定性が思考をサポートします。'
    },
    {
      question: 'AIを使ったクリエイティブ作業にも向いていますか?',
      answer: 'はい。生成AIでアウトプットした画像の修正、プロンプト設計時の図解、アイデアスケッチなど、"描く×考える"を往復する作業に最適です。画面を閲覧するだけでなく、手を動かしながら思考する方に向けた角度設計となっています。'
    },
    {
      question: '角度はどのように調整しますか?',
      answer: '折り紙発想のOrigami Structureにより、折る位置を変えるだけで複数角度に切り替え可能です。複雑なパーツ操作は不要で、「折る→置く→描く」の3ステップで使用できます。'
    },
    {
      question: 'Apple Pencilは収納できますか?',
      answer: 'マグネット式の脱着式ペンホルダーが付属します。必要なときに本体へ磁力で吸着させて装着する仕組みです。磁力はMeVER独自設計で強化しており、カバンの中や携帯時でも外れにくい仕様に改善しています。\n\nさらに、本体の"表面側"と"裏面側"で磁力強度を変えています。表面側は使用時に外しやすく、裏面側はより強力に吸着し外れにくい設計です。実際に使うとわかる、細かなユーザビリティ向上にこだわりました。'
    },
    {
      question: '重量はどのくらいですか?',
      answer: 'iPad Air 11"モデルは約358g、iPad 10.9"モデルは約363g、iPad miniモデルは約218gです。\n\n※ 重量はペンケースを含んだ重さです。\n※ 多少の誤差はあります。'
    },
    {
      question: '初期不良があった場合はどうしたらよいですか?',
      answer: '商品到着後14日以内に、プロジェクトページの「実行者にメッセージ」よりご連絡ください。状況確認の上、交換または返金にて対応いたします。'
    },
    {
      question: '長時間使用しても安定しますか?',
      answer: '描画中や思考整理中に角度がズレにくい構造設計を採用しています。机上・カフェテーブル・共有デスクなど様々な環境での使用を想定し検証を行っています。'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 px-6 bg-[#F8F6FA]">
      <div className="max-w-4xl mx-auto">
        {/* 見出し */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-3 mb-6">
            <span className="w-12 h-px bg-[#8B6BAE]"></span>
            <p className="text-sm tracking-[0.3em] text-[#8B6BAE] uppercase">FAQ</p>
            <span className="w-12 h-px bg-[#8B6BAE]"></span>
          </div>
          <h2
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C2C2C] mb-4 leading-tight"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            よくある<span className="text-[#8B6BAE]">質問</span>
          </h2>
          <p className="text-base text-[#6B6B6B] font-light">
            ご購入前の疑問にお答えします
          </p>
        </div>

        {/* FAQ リスト */}
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`rounded-xl overflow-hidden transition-all duration-300 ${
                openIndex === index 
                  ? 'bg-white border border-[#8B6BAE]' 
                  : 'bg-white border border-[#E8E8E8]'
              }`}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 flex items-center justify-between text-left cursor-pointer"
              >
                <div className="flex items-center gap-3 flex-1">
                  <span className={`text-xs font-medium px-2 py-1 rounded-md ${
                    openIndex === index 
                      ? 'bg-[#8B6BAE] text-white' 
                      : 'bg-[#F0EBF5] text-[#8B6BAE]'
                  }`}>Q</span>
                  <span className="text-sm font-medium text-[#2C2C2C]">{faq.question}</span>
                </div>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full transition-all ${
                  openIndex === index 
                    ? 'bg-[#8B6BAE] text-white rotate-180' 
                    : 'bg-[#F0EBF5] text-[#8B6BAE]'
                }`}>
                  <i className="ri-arrow-down-s-line text-base"></i>
                </div>
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 pb-5">
                  <div className="bg-[#F8F6FA] rounded-lg p-4 ml-9">
                    <div className="flex items-start gap-2">
                      <span className="text-xs font-medium px-2 py-1 rounded-md bg-white text-[#8B6BAE] border border-[#E8E8E8]">A</span>
                      <p className="text-sm text-[#4A4A4A] leading-relaxed whitespace-pre-line flex-1">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
